import { LANGUAGE_LOADED } from "../../Actions/actionTypes";

export const languageReducer = (state = {}, action) => {
  switch (action.type) {
    case LANGUAGE_LOADED:
      return action.payload;
    default:
      return state;
  }
};

export const loadLanguage = (culture, posId, dispatch, config) => {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  const getJson = (f) => {
    return fetch(f).then((x) =>
      x.json().catch(() => {
        // Could not parse file
      })
    );
  };

  const merge = (o, rest) => {
    var next = rest.pop();
    if (!next) return o;

    const merged = {
      ...o,
      ...next,
    };

    return merge(merged, rest);
  };

  const generalUri = `${process.env.PUBLIC_URL}/language.${culture}.json`;
  const specificUri = `${config.baseUrl}/ee-static/checkout/pos-${
    params.pos ? params.pos : posId
  }/Language/language.${culture}.json`;

  const files = [specificUri, generalUri].map((f) => getJson(f));

  Promise.all(files)
    .then((response) => merge({}, response))
    .then((json) => {
      dispatch({
        type: LANGUAGE_LOADED,
        payload: json,
      });
    });
};
